import { AutogenModelCallinScriptTemplateDetail, AutogenRowCallinScriptTemplateDetail } from "./autogen/AutogenModelCallinScriptTemplateDetail";

export class ModelCallinScriptTemplateDetail extends AutogenModelCallinScriptTemplateDetail<RowCallinScriptTemplateDetail> {
	constructor() {
		super(RowCallinScriptTemplateDetail);
	}
}

export class RowCallinScriptTemplateDetail extends AutogenRowCallinScriptTemplateDetail {
}